(function () {
  var STORAGE_KEY = 'horizon:wishlist:v1';
  var cfg = window.__HORIZON_WISHLIST__ || {};
  var i18n = cfg.i18n || {};

  function readList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    var seen = {};
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var h = list[i] && list[i].handle;
      if (!h || seen[h]) continue;
      seen[h] = true;
      out.push({ handle: String(h), id: list[i].id != null ? list[i].id : null });
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(out));
    window.dispatchEvent(new CustomEvent('horizon:wishlist'));
  }

  function has(handle) {
    var list = readList();
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) return true;
    }
    return false;
  }

  function toggle(handle, id) {
    var list = readList();
    var next = [];
    var removed = false;
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) {
        removed = true;
        continue;
      }
      next.push(list[i]);
    }
    if (!removed) next.push({ handle: handle, id: id });
    writeList(next);
    return !removed;
  }

  function syncToggles() {
    var list = readList();
    var set = {};
    for (var i = 0; i < list.length; i++) set[list[i].handle] = true;
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var h = btn.getAttribute('data-product-handle');
      if (!h) return;
      var on = !!set[h];
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
      var addL = i18n.addToWishlist || 'Save to wishlist';
      var remL = i18n.removeFromWishlist || 'Remove from wishlist';
      btn.setAttribute('aria-label', on ? remL : addL);
    });
  }

  function syncCounts() {
    var n = readList().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.classList.toggle('is-visible', n > 0);
    });
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var cur = cfg.currency || 'USD';
    try {
      return new Intl.NumberFormat(cfg.locale || undefined, {
        style: 'currency',
        currency: cur
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function fetchRootUrl() {
    var root = (cfg.routes && cfg.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root;
  }

  function parsePriceCents(product) {
    var priceCents = product.price;
    if (priceCents == null && product.price_min != null) priceCents = product.price_min;
    if (typeof priceCents === 'string') priceCents = parseFloat(priceCents, 10);
    if ((priceCents == null || isNaN(priceCents)) && product.variants && product.variants[0]) {
      priceCents = product.variants[0].price;
      if (typeof priceCents === 'string') priceCents = parseFloat(priceCents, 10);
    }
    return priceCents;
  }

  function parseCompareCents(product) {
    var c = product.compare_at_price;
    if (c == null && product.compare_at_price_min != null) c = product.compare_at_price_min;
    if (typeof c === 'string') c = parseFloat(c, 10);
    if ((c == null || isNaN(c)) && product.variants && product.variants[0]) {
      c = product.variants[0].compare_at_price;
      if (typeof c === 'string') c = parseFloat(c, 10);
    }
    return c;
  }

  function fetchWishlistRows(list, callback) {
    var root = fetchRootUrl();
    var pending = list.map(function (entry) {
      return fetch(root + 'products/' + encodeURIComponent(entry.handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('fetch');
          return r.json();
        })
        .then(function (product) {
          return { entry: entry, product: product };
        })
        .catch(function () {
          return { entry: entry, product: null };
        });
    });
    Promise.all(pending).then(callback);
  }

  function wishlistToggleHtml(handle, productId) {
    var idStr = productId != null && !isNaN(productId) ? String(productId) : '';
    var addL = escapeHtml(i18n.addToWishlist || 'Save to wishlist');
    return (
      '<button type="button" class="wishlist-toggle" data-wishlist-toggle data-product-handle="' +
      escapeHtml(handle) +
      '" data-product-id="' +
      escapeHtml(idStr) +
      '" aria-pressed="false" aria-label="' +
      addL +
      '"><span class="wishlist-toggle__icons" aria-hidden="true"><span class="wishlist-toggle__icon wishlist-toggle__icon--off">' +
      '</span><span class="wishlist-toggle__icon wishlist-toggle__icon--on"></span></span></button>'
    );
  }

  function normalizeProductImageUrl(url) {
    if (!url || typeof url !== 'string') return null;
    url = url.trim();
    if (!url) return null;
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function productImageUrl(product) {
    if (!product) return null;
    var img = product.featured_image;
    if (typeof img === 'string') {
      var s = normalizeProductImageUrl(img);
      if (s) return s;
    }
    if (typeof img === 'object' && img && img.src) {
      return normalizeProductImageUrl(img.src);
    }
    if (product.images && product.images.length) {
      var first = product.images[0];
      var fromArr =
        typeof first === 'string' ? first : first && typeof first === 'object' ? first.src : null;
      var u = normalizeProductImageUrl(fromArr);
      if (u) return u;
    }
    return null;
  }

  function firstVariantId(product) {
    if (product.variants && product.variants[0] && product.variants[0].id != null) {
      return parseInt(product.variants[0].id, 10);
    }
    if (product.id != null) return parseInt(product.id, 10);
    return null;
  }

  function readGridConfig(mount) {
    var maxRaw = mount.getAttribute('data-max-items');
    var maxItems = parseInt(maxRaw, 10);
    if (isNaN(maxItems) || maxItems < 1) maxItems = 24;
    return {
      showVendor: mount.getAttribute('data-show-vendor') === 'true',
      showRemove: mount.getAttribute('data-show-remove') === 'true',
      hideCompareAt: mount.getAttribute('data-hide-compare-at') === 'true',
      imageRatio: mount.getAttribute('data-image-ratio') || 'square',
      cardShadow: mount.getAttribute('data-card-shadow') || 'subtle',
      titleSize: mount.getAttribute('data-card-title-size') || 'medium',
      showShipping: mount.getAttribute('data-show-shipping-badge') === 'true',
      maxItems: maxItems,
      placeholder: mount.getAttribute('data-placeholder') || ''
    };
  }

  function mediaRatioClass(ratio) {
    if (ratio === 'portrait_45') return 'wishlist-grid__media--45';
    if (ratio === 'landscape_43') return 'wishlist-grid__media--43';
    return 'wishlist-grid__media--square';
  }

  function truncateTitle(title, maxLen) {
    if (!title || title.length <= maxLen) return title;
    return title.slice(0, maxLen) + '...';
  }

  function buildCollectionCardHtml(product, handle, gcfg) {
    var root = fetchRootUrl();
    var url = product.url || root + 'products/' + handle;
    var title = truncateTitle(product.title || handle, 50);
    var priceCents = parsePriceCents(product);
    var compareCents = parseCompareCents(product);
    var priceStr = formatMoney(priceCents);
    var vid = firstVariantId(product);
    var imgUrl = productImageUrl(product);
    var arClass = mediaRatioClass(gcfg.imageRatio);
    var shadowClass = 'wishlist-grid__card--shadow-' + escapeHtml(gcfg.cardShadow || 'subtle');
    var titleClass = 'wishlist-grid__card--title-' + escapeHtml(gcfg.titleSize || 'medium');

    var vendorBlock = '';
    if (gcfg.showVendor && product.vendor) {
      vendorBlock = '<p class="wishlist-grid__vendor">' + escapeHtml(product.vendor) + '</p>';
    }

    var priceBlock = '';
    if (priceStr) {
      var showCompare =
        !gcfg.hideCompareAt &&
        compareCents != null &&
        !isNaN(compareCents) &&
        compareCents > priceCents;
      if (showCompare) {
        var compareStr = formatMoney(compareCents);
        var offPct = Math.round(((compareCents - priceCents) / compareCents) * 100);
        var offLabel = '';
        if (i18n.compareSavings && String(i18n.compareSavings).indexOf('__PCT__') !== -1) {
          offLabel = String(i18n.compareSavings).replace('__PCT__', String(offPct));
        } else {
          offLabel = '(' + offPct + '% off)';
        }
        priceBlock =
          '<p class="wishlist-grid__price">' +
          '<span class="wishlist-grid__price-sale">' +
          escapeHtml(priceStr) +
          '</span>' +
          '<span class="wishlist-grid__price-compare">' +
          escapeHtml(compareStr) +
          '</span>' +
          '<span class="wishlist-grid__price-off">' +
          escapeHtml(offLabel) +
          '</span></p>';
      } else {
        priceBlock = '<p class="wishlist-grid__price">' + escapeHtml(priceStr) + '</p>';
      }
    }

    var shipBlock = '';
    if (gcfg.showShipping && i18n.freeShippingBadge) {
      shipBlock = '<p class="wishlist-grid__shipping">' + escapeHtml(i18n.freeShippingBadge) + '</p>';
    }

    var removeBlock = '';
    if (gcfg.showRemove) {
      removeBlock =
        '<button type="button" class="wishlist-grid__remove" data-wishlist-remove="' +
        escapeHtml(handle) +
        '">' +
        escapeHtml(i18n.remove || 'Remove') +
        '</button>';
    }

    var mediaInner = '';
    if (imgUrl) {
      mediaInner =
        '<a class="wishlist-grid__media ' +
        arClass +
        '" href="' +
        escapeHtml(url) +
        '"><img src="' +
        escapeHtml(imgUrl) +
        '" alt="" loading="lazy" width="600" height="600"></a>';
    } else {
      mediaInner =
        '<div class="wishlist-grid__media ' +
        arClass +
        '"><span class="wishlist-grid__placeholder">' +
        escapeHtml(gcfg.placeholder) +
        '</span></div>';
    }

    return (
      '<li class="wishlist-grid__item"><article class="wishlist-grid__card ' +
      shadowClass +
      ' ' +
      titleClass +
      '">' +
      '<div class="wishlist-grid__media-wrap">' +
      mediaInner +
      '<div class="wishlist-grid__wishlist-slot">' +
      wishlistToggleHtml(handle, vid) +
      '</div></div><div class="wishlist-grid__info">' +
      vendorBlock +
      '<h3 class="wishlist-grid__title"><a href="' +
      escapeHtml(url) +
      '">' +
      escapeHtml(title) +
      '</a></h3>' +
      priceBlock +
      shipBlock +
      removeBlock +
      '</div></article></li>'
    );
  }

  function injectWishlistIconsInGrid(html) {
    var offSvg = (cfg.svgHeartOff || '').trim();
    var onSvg = (cfg.svgHeartOn || '').trim();
    if (!offSvg && !onSvg) return html;
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    wrap.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var off = btn.querySelector('.wishlist-toggle__icon--off');
      var on = btn.querySelector('.wishlist-toggle__icon--on');
      if (off && offSvg) off.innerHTML = offSvg;
      if (on && onSvg) on.innerHTML = onSvg;
    });
    return wrap.innerHTML;
  }

  function renderWishlistPage() {
    var grid = document.getElementById('wishlist-page-grid');
    var empty = document.getElementById('wishlist-page-empty');
    if (!grid || !empty) return;

    var list = readList();
    if (list.length === 0) {
      empty.hidden = false;
      grid.hidden = true;
      grid.innerHTML = '';
      return;
    }

    empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = '';

    fetchWishlistRows(list, function (rows) {
      rows.forEach(function (row) {
        var product = row.product;
        var handle = row.entry.handle;
        var li = document.createElement('li');
        if (!product) {
          li.className = 'wishlist-page__item wishlist-page__item--unavailable';
          li.innerHTML =
            '<p class="wishlist-page__unavailable">' +
            escapeHtml(i18n.unavailable || 'Product unavailable') +
            '</p><button type="button" class="wishlist-page__remove" data-wishlist-remove="' +
            escapeHtml(handle) +
            '">' +
            escapeHtml(i18n.remove || 'Remove') +
            '</button>';
          grid.appendChild(li);
          return;
        }

        li.className = 'wishlist-page__item';
        var imgUrl = productImageUrl(product);
        var priceCents = parsePriceCents(product);
        var priceStr = formatMoney(priceCents);
        var title = product.title || handle;
        var root = fetchRootUrl();
        var url = product.url || root + 'products/' + handle;

        var thumb = '';
        if (imgUrl) {
          thumb =
            '<a class="wishlist-page__thumb" href="' +
            escapeHtml(url) +
            '"><img src="' +
            escapeHtml(imgUrl) +
            '" alt="" loading="lazy" width="200" height="200"></a>';
        } else {
          thumb = '<div class="wishlist-page__thumb wishlist-page__thumb--empty"></div>';
        }

        li.innerHTML =
          thumb +
          '<div class="wishlist-page__meta">' +
          '<a class="wishlist-page__title" href="' +
          escapeHtml(url) +
          '">' +
          escapeHtml(title) +
          '</a>' +
          (priceStr ? '<p class="wishlist-page__price">' + escapeHtml(priceStr) + '</p>' : '') +
          '</div>' +
          '<button type="button" class="wishlist-page__remove" data-wishlist-remove="' +
          escapeHtml(handle) +
          '" aria-label="' +
          escapeHtml(i18n.removeFromWishlist || i18n.remove || 'Remove') +
          '">' +
          escapeHtml(i18n.remove || 'Remove') +
          '</button>';

        grid.appendChild(li);
      });
    });
  }

  function renderWishlistCollectionGrids() {
    var mounts = document.querySelectorAll('[data-wishlist-collection-grid]');
    if (!mounts.length) return;

    var list = readList();
    if (list.length === 0) {
      mounts.forEach(function (mount) {
        var listEl = mount.querySelector('[data-wishlist-grid-list]');
        var sectionRoot = mount.closest('.wishlist-grid');
        var emptyEl = sectionRoot ? sectionRoot.querySelector('[data-wishlist-grid-empty]') : null;
        if (listEl) listEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
      });
      return;
    }

    var globalMax = 1;
    mounts.forEach(function (m) {
      var n = readGridConfig(m).maxItems;
      if (n > globalMax) globalMax = n;
    });
    var capped = list.slice(0, globalMax);

    fetchWishlistRows(capped, function (rows) {
      mounts.forEach(function (mount) {
        var listEl = mount.querySelector('[data-wishlist-grid-list]');
        var sectionRoot = mount.closest('.wishlist-grid');
        var emptyEl = sectionRoot ? sectionRoot.querySelector('[data-wishlist-grid-empty]') : null;
        if (!listEl) return;

        if (emptyEl) emptyEl.hidden = true;
        var gcfg = readGridConfig(mount);
        var subRows = rows.slice(0, gcfg.maxItems);
        var html = '';
        subRows.forEach(function (row) {
          var product = row.product;
          var handle = row.entry.handle;
          if (!product) {
            html +=
              '<li class="wishlist-grid__item wishlist-grid__item--unavailable"><article class="wishlist-grid__card"><p class="wishlist-grid__unavailable">' +
              escapeHtml(i18n.unavailable || 'Product unavailable') +
              '</p><button type="button" class="wishlist-grid__remove" data-wishlist-remove="' +
              escapeHtml(handle) +
              '">' +
              escapeHtml(i18n.remove || 'Remove') +
              '</button></article></li>';
            return;
          }
          html += buildCollectionCardHtml(product, handle, gcfg);
        });
        listEl.innerHTML = injectWishlistIconsInGrid(html);
      });
      syncToggles();
    });
  }

  function refreshAll() {
    renderWishlistPage();
    renderWishlistCollectionGrids();
  }

  function onDocumentClick(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    var idAttr = btn.getAttribute('data-product-id');
    var id = idAttr ? parseInt(idAttr, 10) : null;
    if (!handle) return;
    toggle(handle, id);
    syncToggles();
    syncCounts();
    refreshAll();
  }

  function onRemoveClick(e) {
    var btn = e.target.closest('[data-wishlist-remove]');
    if (!btn) return;
    var handle = btn.getAttribute('data-wishlist-remove');
    if (!handle) return;
    var list = readList().filter(function (x) {
      return x.handle !== handle;
    });
    writeList(list);
    syncToggles();
    syncCounts();
    refreshAll();
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('click', onRemoveClick);
  window.addEventListener('horizon:wishlist', function () {
    syncToggles();
    syncCounts();
    refreshAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    syncToggles();
    syncCounts();
    refreshAll();
  }

  window.HorizonWishlist = {
    read: readList,
    has: has,
    toggle: toggle,
    sync: function () {
      syncToggles();
      syncCounts();
      refreshAll();
    }
  };
})();
